import React, { useEffect, useRef } from 'react'
import Talk from 'talkjs'
import SingleChatView from '../component/SingleChatView'
import { CONFIG } from '../../../../Config/config'
import { notificationHandler } from '../../utils'

const { appID } = CONFIG.TALKJS

const SingleChat = ({
  userId,
  conversationId,
  selectedCities,
  showOnlyUnread,
  getUnreadStatuses,
  setViewType,
  setNotificationConversation,
}) => {
  let ref = useRef(null)
  const initChat = async ({ conversationId, ref, userId }) => {
    await Talk.ready

    const me = new Talk.User(userId)
    const session = new Talk.Session({
      appId: appID,
      me,
    })

    const conversation = conversationId
      ? session.getOrCreateConversation(conversationId)
      : null
    const inbox = session.createInbox()

    session.unreads.onChange(async unreadConversations => {
      await getUnreadStatuses()
    })

    const filterOptions = showOnlyUnread
      ? {
          hasUnreadMessages: true,
          custom: {
            cityName: ['oneOf', selectedCities],
            spyLink: '!exists',
            isClientChat: '!exists',
          },
        }
      : {
          custom: {
            cityName: ['oneOf', selectedCities],
            spyLink: '!exists',
            isClientChat: '!exists',
          },
        }

    inbox.setFeedFilter({
      custom: { spyLink: '!exists', isClientChat: '!exists' },
    })

    if (showOnlyUnread) {
      inbox.setFeedFilter({
        hasUnreadMessages: true,
        custom: { spyLink: '!exists', isClientChat: '!exists' },
      })
    }

    if (selectedCities.length && !selectedCities.includes('All')) {
      inbox.setFeedFilter({
        ...filterOptions,
      })
    }

    session.onDesktopNotificationClicked(data => {
      setNotificationConversation(data.conversation.id)
      notificationHandler({ data, inbox, session, setViewType })
    })

    inbox.select(conversation)
    inbox.mount(ref)
  }

  useEffect(() => {
    if (userId) {
      initChat({
        conversationId,
        ref,
        userId,
      })
    }
  }, [conversationId, selectedCities, showOnlyUnread])

  const setRef = value => {
    ref = value
  }

  return <SingleChatView setRef={setRef} />
}

export default SingleChat
